<template>
  <div id="center-1">
    <div class="first">
      <div class="word">总营业额</div>
      <div class="sum-num">
        <div
          :class="[item == ',' || item == '.' ? 'color-bg' : 'fill-bg']"
          v-for="(item, index) in showList"
          :key="index"
        >
          <span class="num-clor">
            {{ item }}
          </span>
        </div>
      </div>
      <div class="word">元</div>
    </div>
    <div class="row">
      <!-- 设备总数 -->
      <div class="row-item">
        <div class="num">{{ chargingCount }}</div>
        <div class="tip">设备总数(台)</div>
        <div class="img">
          <img src="../../assets/pgzl-device-bg.png" alt="" />
        </div>
      </div>
      <!-- 端口总数 -->
      <div class="row-item">
        <div class="num">{{ socketCount }}</div>
        <div class="tip">端口总数(个)</div>
        <div class="img">
          <img src="../../assets/pgzl-socket-bg-2.png" alt="" />
        </div>
      </div>
      <!-- 用电总度数 -->
      <div class="row-item">
        <div class="num">{{ totalElectricity }}</div>
        <div class="tip">用电总度数(度)</div>
        <div class="img">
          <img src="../../assets/pgzl-meter-bg.png" alt="" />
        </div>
      </div>
      <!-- 用户总数 -->
      <div class="row-item">
        <div class="num">{{ memberCount }}</div>
        <div class="tip">用户总数(人)</div>
        <div class="img">
          <img src="../../assets/pgzl-user-bg.png" alt="" />
        </div>
      </div>
      <!-- 今日订单数 -->
      <div class="row-item">
        <div class="num">{{ orderCount }}</div>
        <div class="tip">订单总数(个)</div>
        <div class="img">
          <img src="../../assets/pgzl-order-bg.png" alt="" />
        </div>
      </div>
      <!-- 今日营业额 -->
      <div class="row-item">
        <!-- <div class="num">{{ orderAmount }}</div> -->
        <div class="num">{{unitPrice}}</div>
        <div class="tip">客单件(元)</div>
        <div class="img">
          <img src="../../assets/pgzl-price.png" alt="" />
        </div>
      </div>
    </div>
    <div class="row-flex" style="padding-top: 15px">
      <div>
        <!-- <div id="chart1" ref="main1" style="width:100%;height:200px"></div> -->
        <!-- <leftPie></leftPie> -->
        <div
          id="chartLeft"
          ref="mainLeft"
          style="width: 100%; height: 200px"
        ></div>
        <div class="words">近7日订单时长</div>
      </div>
      <div>
        <!-- <div id="chart2" ref="main2" style="width:100%;height:200px"></div> -->
        <!-- <rightPie></rightPie> -->
        <div
          id="chartRight"
          ref="mainRight"
          style="width: 100%; height: 200px"
        ></div>
        <div class="words">近7日订单功率</div>
      </div>
    </div>
  </div>
</template>
<script>
import { timerSeter } from "@/utils";
import leftPie from "./pie-center/left-pie.vue";
import rightPie from "./pie-center/right-pie.vue";
export default {
  data() {
    return {
      timer: null,
      showList: [],
      totalTurnover: 0, //总营业额
      totalElectricity: 0, //总用电量
      chargingCount: 0, //设备总数
      socketCount: 0, //端口总数
      regionCount: "", //覆盖城市数
      memberCount: 0, //用户总数
      orderCount: 0, //总订单数
      orderAmount: "", //今日总营业额
      unitPrice:0,//客单价
      echartAreaLeft: null,
      echartAreaRight: null,
      souceDataLeftName: [],
      souceDataLeftValue: [],
      souceDataRightName: [],
      souceDataRightValue: [],
    };
  },
  props: {
    level: "",
    regionId: "",
  },
  components: {
    leftPie,
    rightPie,
  },
  created() {
    // setInterval(()=>{
    //   this.getData()
    // },1000*10)
    // this.timer = setInterval(() => {
    //   setTimeout(this.init(), 0);
    // }, 1000 * 10);
  },
  mounted() {
    // this.initChart()
    this.init();
  },
  methods: {
    formatNum(num) {
      let digNum = String(this.totalTurnover).replace(
        /(\d{1,3})(?=(\d{3})+(?:$|\.))/g,
        "$1,"
      );
      this.showList = digNum.toString().split("");
      // console.log("00000", this.showList);
    },
    init() {
      this.echartAreaLeft = this.$echarts.init(this.$refs.mainLeft);
      this.echartAreaRight = this.$echarts.init(this.$refs.mainRight);
      this.getTwoEchartsData();
      this.getTimeData();
    },
    // 获取总营业额、设备总数、端口总数、用电总数等数据
    getTimeData() {
      this.$http({
        url: this.$http.adornUrl(
          "/admin/api/realTime/getRealTimeBasicDataByStatRegionBusiData"
        ),
        method: "get",
        params: this.$http.adornParams({
          findType: 1,
          regionId: this.regionId,
        }),
      }).then(({ data }) => {
        if (data.code == 0) {
          this.totalElectricity = data.data.nevTotalElectricity;
          this.chargingCount = data.data.nevChargingCount;
          this.socketCount = data.data.nevSocketCount;
          this.memberCount = data.data.nevMemberCount;
          this.orderCount = data.data.nevOrderCountSum;
          this.unitPrice = (data.data.nevTotalTurnover/data.data.nevOrderCountSum).toFixed(2)
          let digNum = String(data.data.nevTotalTurnover).replace(
            /(\d{1,3})(?=(\d{3})+(?:$|\.))/g,
            "$1,"
          );
          this.showList = digNum.toString().split("");
        }
      });
    },

    getTwoEchartsData() {
      this.getoption2Dataleft();
      this.getoption2DataRight();
    },
    // 组件2的数据源 近7日订单充电时长饼图数据
    getoption2Dataleft() {
      this.souceDataLeftValue = [];
      this.$http({
        url: this.$http.adornUrl("/admin/api/realTime/getChargingTime"),
        method: "get",
        params: this.$http.adornParams({
          findType: 1,
          regionId: this.regionId,
        }),
      }).then(({ data }) => {
        console.log(data, "汽车订单时长222222");
        if (data.code == 0) {
          data.data.keys.forEach((item, index) => {
            var obj = {};
            obj.name = item;
            obj.value = data.data.values1[index];
            this.souceDataLeftValue.push(obj);
          });
          this.updatedChartLeft();
        }
      });
    },
    // 组件2的数据源 近7日订单最大功率饼图数据
    getoption2DataRight() {
      this.souceDataRightValue = [];
      this.$http({
        url: this.$http.adornUrl("/admin/api/realTime/getChargingMaxPower"),
        method: "get",
        params: this.$http.adornParams({
          findType: 1,
          regionId: this.regionId,
        }),
      }).then(({ data }) => {
        console.log(data, "近七日功率00000");
        if (data.code == 0) {
          data.data.keys.forEach((item, index) => {
            var obj = {};
            obj.name = item;
            obj.value = data.data.values1[index];
            this.souceDataRightValue.push(obj);
          });
          this.updatedChartRight();
        }
      });
    },
    updatedChartLeft() {
      var data = this.souceDataLeftValue;
      // var data = [
      //   {
      //     name: "使用中资源量",
      //     value: 0,
      //   },
      //   {
      //     name: "维修中资源量",
      //     value: 20,
      //   },
      //   {
      //     name: "保养中资源量",
      //     value: 0,
      //   },
      //   {
      //     name: "已损坏资源量",
      //     value: 0,
      //   },
      // ];
      var arrName = getArrayValue(data, "name");
      var arrValue = getArrayValue(data, "value");
      var sumValue = eval(arrValue.join("+"));
      var objData = array2obj(data, "name");
      var optionData = getData(data);
      function getArrayValue(array, key) {
        var key = key || "value";
        var res = [];
        if (array) {
          array.forEach(function (t) {
            res.push(t[key]);
          });
        }
        return res;
      }

      function array2obj(array, key) {
        var resObj = {};
        for (var i = 0; i < array.length; i++) {
          resObj[array[i][key]] = array[i];
        }
        return resObj;
      }

      function getData(data) {
        var res = {
          series: [],
          yAxis: [],
        };
        for (let i = 0; i < data.length; i++) {
          res.series.push({
            name: "时长",
            type: "pie",
            clockWise: false, //顺时加载
            hoverAnimation: false, //鼠标移入变大
            radius: [85 - i * 15 + "%", 92 - i * 15 + "%"],
            center: ["45%", "50%"],
            label: {
              show: false,
            },
            itemStyle: {
              label: {
                show: false,
              },
              labelLine: {
                show: false,
              },
              borderWidth: 5,
            },
            data: [
              {
                value: data[i].value * 0.75,
                name: data[i].name,
              },
              {
                value: sumValue - data[i].value * 0.75,
                name: "",
                itemStyle: {
                  color: "rgba(0,0,0,0)",
                  borderWidth: 0,
                },
                tooltip: {
                  show: false,
                },
                hoverAnimation: false,
              },
            ],
          });
          res.series.push({
            name: "",
            type: "pie",
            silent: true,
            z: 1,
            clockWise: false, //顺时加载
            hoverAnimation: false, //鼠标移入变大
            radius: [85 - i * 15 + "%", 92 - i * 15 + "%"],
            center: ["45%", "50%"],
            label: {
              show: false,
            },
            itemStyle: {
              label: {
                show: false,
              },
              labelLine: {
                show: false,
              },
              borderWidth: 5,
            },
            data: [
              {
                value: 7.5,
                itemStyle: {
                  color: "rgba(2, 154, 255, 0.27)",
                  borderWidth: 0,
                },
                hoverAnimation: false,
                tooltip: {
                  show: false,
                },
                hoverAnimation: false,
              },
              {
                value: 2.5,
                name: "",
                itemStyle: {
                  color: "rgba(0,0,0,0)",
                  borderWidth: 0,
                },
                tooltip: {
                  show: false,
                },
                hoverAnimation: false,
              },
            ],
          });
          res.yAxis.push(
            data[i].name +
              "   " +
              ((data[i].value / sumValue) * 100).toFixed(2) +
              "%"
          );
        }
        return res;
      }

      const option = {
        // backgroundColor: "#fff",
        title: {
          text: "{a| }",
          // text:"",
          x: 180,
          y: 70,
          textStyle: {
            fontFamily: "MicrosoftYaHei-Bold, MicrosoftYaHei",
            fontWeight: "bold",
            // color: "#fff",
            rich: {
              a: {
                color: "#fff",
                fontSize: 16,
                height: 50,
                width: 50,
                backgroundColor: {
                  image: require("../../assets/icon-pie1.png"),
                },
              },
            },
          },
        },
        tooltip: {
          show: true,
          trigger: "item",
          formatter: "{a}<br>{b}:{c}({d}%)",
        },
        color: [
          "rgba(0, 145, 255, 1)",
          "rgba(68, 215, 182, 1)",
          "rgba(247, 181, 0, 1)",
          "rgba(250, 100, 0, 1)",
        ],
        grid: {
          top: "0%",
          bottom: "65%",
          left: "45%",
          containLabel: false,
        },
        yAxis: [
          {
            type: "category",
            inverse: true,
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              interval: 0,
              inside: true,
              textStyle: {
                color: "#fff",
                fontSize: 10,
              },
              show: true,
            },
            data: optionData.yAxis,
          },
        ],
        xAxis: [
          {
            show: false,
          },
        ],
        series: optionData.series,
      };
      this.echartAreaLeft.setOption(option);
    },
    updatedChartRight() {
      var data = this.souceDataRightValue;
      var arrValue = getArrayValue(data, "value");
      var sumValue = eval(arrValue.join("+"));
      function getArrayValue(array, key) {
        var key = key || "value";
        var res = [];
        if (array) {
          array.forEach(function (t) {
            res.push(t[key]);
          });
        }
        return res;
      }

      var optionData = getData(data);
      function getData(data) {
        var res = {
          series: [],
          yAxis: [],
        };
        for (let i = 0; i < data.length; i++) {
          res.series.push({
            name: "功率",
            type: "pie",
            clockWise: false, //顺时加载
            hoverAnimation: false, //鼠标移入变大
            radius: [85 - i * 15 + "%", 92 - i * 15 + "%"],
            center: ["45%", "50%"],
            label: {
              show: false,
            },
            itemStyle: {
              label: {
                show: false,
              },
              labelLine: {
                show: false,
              },
              borderWidth: 5,
            },
            data: [
              {
                value: data[i].value * 0.75,
                name: data[i].name,
              },
              {
                // value: sumValue - data[i].value,
                value: sumValue - data[i].value * 0.75,
                name: "",
                itemStyle: {
                  color: "rgba(0,0,0,0)",
                  borderWidth: 0,
                },
                tooltip: {
                  show: false,
                },
                hoverAnimation: false,
              },
            ],
          });
          res.series.push({
            name: "",
            type: "pie",
            silent: true,
            z: 1,
            clockWise: false, //顺时加载
            hoverAnimation: false, //鼠标移入变大
            radius: [85 - i * 15 + "%", 92 - i * 15 + "%"],
            center: ["45%", "50%"],
            label: {
              show: false,
            },
            itemStyle: {
              label: {
                show: false,
              },
              labelLine: {
                show: false,
              },
              borderWidth: 5,
            },
            data: [
              {
                value: 7.5,
                itemStyle: {
                  color: "rgba(2, 154, 255, 0.27)",
                  borderWidth: 0,
                },
                tooltip: {
                  show: false,
                },
                hoverAnimation: false,
              },
              {
                value: 2.5,
                name: "",
                itemStyle: {
                  color: "rgba(0,0,0,0)",
                  borderWidth: 0,
                },
                tooltip: {
                  show: false,
                },
                hoverAnimation: false,
              },
            ],
          });
          res.yAxis.push(
            data[i].name +
              "   " +
              ((data[i].value / sumValue) * 100).toFixed(2) +
              "%"
          );
        }
        return res;
      }

      const option = {
        // backgroundColor: "#fff",
        title: {
          text: "{a| }",
          // text:"",
          x: 185,
          y: 70,
          textStyle: {
            fontFamily: "MicrosoftYaHei-Bold, MicrosoftYaHei",
            fontWeight: "bold",
            // color: "#fff",
            rich: {
              a: {
                color: "#fff",
                fontSize: 16,
                height: 50,
                width: 50,
                backgroundColor: {
                  image: require("../../assets/icon-pie2.png"),
                },
              },
            },
          },
        },
        tooltip: {
          show: true,
          trigger: "item",
          formatter: "{a}<br>{b}:{c}({d}%)",
        },
        color: ["rgba(0, 145, 255, 1)",
          "rgba(68, 215, 182, 1)",
          "rgba(247, 181, 0, 1)",
          "rgba(250, 100, 0, 1)"],
        grid: {
          top: "0%",
          bottom: "65%",
          left: "45%",
          containLabel: false,
        },
        yAxis: [
          {
            type: "category",
            inverse: true,
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              interval: 0,
              inside: true,
              textStyle: {
                color: "#fff",
                fontSize: 10,
              },
              show: true,
            },
            data: optionData.yAxis,
          },
        ],
        xAxis: [
          {
            show: false,
          },
        ],
        series: optionData.series,
      };
      this.echartAreaRight.setOption(option);
      // this.echartArea2.setOption(option)
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },
};
</script>
<style lang="scss" scoped>
#center-1 {
  width: 100%;
  .first {
    display: flex;
    justify-content: center;
    text-align: center;
    margin-bottom: 28px;
    .word {
      font-size: 20px;
      font-weight: bold;
      color: #75b8ff;
      line-height: 80px;
      letter-spacing: 4px;
      margin: 0 20px;
    }
    .sum-num {
      display: flex;
      justify-content: space-around;
      line-height: 80px;
    }
    .fill-bg {
      width: 60px;
      height: 80px;
      background: url("../../assets/pgzl-num-bg.png");
      background-size: 100% 100%;
      font-size: 40px;
      font-weight: bold;
      .num-clor {
        color: #00ecfc;
        text-shadow: 0px 2px 12px rgba(255, 187, 0, 0.44);
        background: linear-gradient(180deg, #fff8c8 0%, #f7b500 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }
    .color-bg {
      font-size: 40px;
      font-weight: bold;
      color: #75b8ff;
    }
  }

  .row {
    width: 100%;
    display: flex;
    justify-content: space-around;
  }
  .row-flex {
    display: grid;
    grid-template-columns: 50% 50%;
  }
  .row-item {
    text-align: center;
    .num {
      font-size: 20px;
      color: #fff;
      margin-bottom: 7px;
    }
    .tip {
      font-size: 12px;
      color: #00ecfc;
    }
    .img {
      width: 100%;
      height: 70px;
      img {
        width: 80px;
        height: 100%;
      }
    }
  }
  .words {
    padding-top: 10px;
    font-size: 21px;
    font-weight: bold;
    color: linear-gradient(180deg, #b3ccff 0%, #36a3ff 100%);
    letter-spacing: 2px;
    text-align: center;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/car-system/option2.vue